import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import lookupsApi from "../../API/lookups.api";
import Select from "react-select";
import SimpleNotification from "../Notifications/SimpleNotification";
import organizationSubscriptionsApi from "../../API/organizationSubscriptions.api";

const DisplayUnitForm = ({
    modelParameterProductVersionId,
    organizationSubscriptionId,
    selectedDisplayUnit,
    setSelectedDisplayUnit,
    availableUnits,
    setAvailableUnits,
    subscriptionMaterialId,
}) => {
    const [isFetching, setIsFetching] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setSelectedDisplayUnit(null);
        if (modelParameterProductVersionId) {
            setIsFetching(true);
            fetchAvailableUnits();
        }
    }, [modelParameterProductVersionId]);

    const fetchAvailableUnits = async () => {
        const result =
            await lookupsApi.getModelParameterProductVersionAvailableUnits(
                modelParameterProductVersionId
            );
        const unitConversionId =
            await organizationSubscriptionsApi.getSelectedDisplayUnit(
                modelParameterProductVersionId,
                organizationSubscriptionId,
                subscriptionMaterialId
            );
        setAvailableUnits(result);
        const selectedUnit = result.find(
            (resultItem) => resultItem.value === unitConversionId
        );
        setSelectedDisplayUnit(selectedUnit ?? null);
        setIsFetching(false);
    };

    return (
        <div className="tags input-group">
            <h4 className="uppercase text-xs">{t("displayUnit")}</h4>
            <Select
                options={availableUnits}
                value={selectedDisplayUnit}
                onChange={setSelectedDisplayUnit}
                placeholder={t("selectDisplayUnit")}
                isClearable
                isLoading={isFetching}
                isDisabled={isFetching || availableUnits.length === 0}
            />
            {availableUnits.length === 0 && !isFetching && (
                <SimpleNotification
                    className="mt-2"
                    message={t("noAvailableDisplayUnits")}
                />
            )}
        </div>
    );
};

export default DisplayUnitForm;
